<template>
  <div class="ac4">
    <!-- 标题 -->
    <div class="ac4-title">
      <h2>最新文章</h2>
    </div>

    <!-- 列表项 -->
    <ul class="ac4-list">
      <!-- 循环项 -->
      <li v-for="(item, index) in data" :key="index" @click="gopay()">
        <i class="iconfont icon-jinru"></i>
        <span>{{ item.title }}</span>
      </li>
    </ul>
    <modal
      title="请微信扫码支付"
      btnType="1"
      modalType="middle"
      :showModal="showModal"
      @submit="showModal = false"
      @cancel="showModal = false"
    >
      <template v-slot:body>
        <img
          style="display: flex; justify-content: center; margin: 0 auto"
          src="/imgs/pay2.png"
        />
        <h2>微信支付：2元/篇</h2>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "./../components/Modal";
export default {
  name: "ac4",
  data() {
    return {
      data: [],
      showModal: false,
    };
  },
  components: {
    Modal,
  },
  mounted() {
    this.init();
    document.title = "北京极海科技有限公司";
  },
  methods: {
    init() {
      this.axios.get("/mock/ac1.json").then((res) => {
        const data = res.data;
        // 两条数据
        this.data = data.splice(0, 9);
        // console.log(this.data);
      });
    },
    // 跳转 逻辑 封装
    goDays(methods, id) {
      this[methods](id);
    },
    // 收费逻辑
    gopay() {
      alert("资讯收费2元，请扫码购买~");
      this.showModal = true;
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.ac4 {
  width: 100%;
  // 标题
  .ac4-title {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #ccc;
    // padding-left: 30px;
    box-sizing: border-box;
    h2 {
      font-size: 16px;
      width: 80px;
      height: 100%;
      line-height: 40px;
      text-align: center;
      border-bottom: 1px solid $colorZ;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        color: $colorZ;
      }
    }
  }

  // 列表
  .ac4-list {
    li {
      width: 100%;
      height: 30px;
      margin: 20px auto;
      display: flex;
      align-items: center;
      padding: 0 10px;
      box-sizing: border-box;

      i {
        font-size: 16px;
        margin-right: 5px;
      }
      span {
        font-size: 14px;
        transition: all 0.3s;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:hover {
          color: $colorZ;
        }
      }
    }
  }
}
</style>
